import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

interface SeoProps {
  description?: string;
  image?: string;
  title: string;
  lang?: string;
  children?: React.ReactNode;
}

function Seo(props: SeoProps) {
  const { description, image, title, lang = 'en', children } = props;

  const { site } = useStaticQuery(graphql`
    query SeoInfoQuery {
      site {
        siteMetadata {
          title
          description
          siteUrl
          social {
            twitter
          }
        }
      }
    }
  `);

  const metaDescription = description ?? site.siteMetadata.description;
  const metaImage = image ?? '/meta/default-meta-image.png';
  const metaImageUrl = metaImage.match(/^https?:\/\//)
    ? metaImage
    : `${site.siteMetadata.siteUrl}${metaImage}`;

  const formattedTitle = `${title ?? 'Welcome'} — ${site.siteMetadata.title}`;

  return (
    <>
      <html lang={lang} />
      <title>{formattedTitle}</title>
      <meta name='description' content={metaDescription} />
      <meta name='theme-color' content='#D04200' />
      <meta name='image' content={metaImageUrl} />
      <meta property='og:title' content={formattedTitle} />
      <meta property='og:description' content={metaDescription} />
      <meta property='og:image' content={metaImageUrl} />
      <meta name='twitter:card' content='summary' />
      <meta name='twitter:creator' content={site.siteMetadata.social.twitter} />
      <meta name='twitter:title' content={formattedTitle} />
      <meta name='twitter:description' content={metaDescription} />
      <meta name='twitter:image' content={metaImageUrl} />
      <link
        rel='icon'
        type='image/png'
        sizes='96x96'
        href='/meta/favicon.png'
      />
      <link
        rel='icon'
        type='image/png'
        sizes='192x192'
        href='/meta/android-chrome.png'
      />
      <link
        rel='apple-touch-icon'
        sizes='180x180'
        href='/meta/apple-touch-icon.png'
      />
      {children}
    </>
  );
}

export default Seo;
